import { apiGet, apiSend } from './client';

export type ReferralFriend = {
  public_id: string;
  short_id?: string;
  display_name: string;
  joined_at?: string | null;
  deposit_total_minor?: number;
  earned_minor: number;
  pending_minor?: number;
  pending_available_at?: string | null;
};

export type ReferralOverview = {
  code: string | null;
  link_path: string | null;
  link_url?: string | null;
  bot_username?: string | null;
  reward_minor_configured: number;
  message: string;
  currency: string;
  signup_bonus_minor: number;
  deposit_commission_bps: number;
  deposit_hold_days?: number;
  invited_count: number;
  earnings_total_minor: number;
  earnings_bonus_minor: number;
  earnings_real_minor: number;
  earnings_pending_minor?: number;
  friends: ReferralFriend[];
  brand: string;
  active: boolean;
};

export async function fetchReferralOverview(): Promise<ReferralOverview> {
  return apiGet<ReferralOverview>('/api/v1/referral');
}

export async function bindReferralCode(referral_code: string): Promise<{
  bound: boolean;
  reason?: string;
  signup_bonus_credited?: boolean;
  signup_bonus_minor?: number;
}> {
  return apiSend('POST', '/api/v1/referral/bind', { referral_code });
}
